import { gql } from "lib/apolloClient";

const configurationItemFragment = gql`
  fragment configurationV2Item on ConfigurationV2 {
    id
    uidV2
    configuration
    aclControlParameterType
    valueType
    value
    isLocked
  }
`;

const configurationUpdateFragment = gql`
  fragment configurationV2UpdateItem on ConfigurationV2 {
    id
    uidV2
    configuration
    aclControlParameterType
    valueType
    value
    isLocked
    channelTypeCategorizedValues(
      filters: { isAdminNotificationManager: $isAdminNotificationManager }
    ) {
      push
      email
      inApp
    }
    platformCategorizedValues(isCourseModuleSetting: $isCourseModuleSetting) {
      default
      staff
      parent
      student
    }
  }
`;

export { configurationItemFragment, configurationUpdateFragment };
